<template>
  <div id="app" :class="cartoonClass" @click.prevent="disableAction()">
    <div class="preventMask" @touchmove.prevent @click="onClose()"></div>  
    <div class="container scrollful" :class="[heightClassFa]">
        <PayHeader :title="titleName" :isBack="isTitleBack" @onClose="onClose"></PayHeader>
        <div class="content" :class="heightClassCh" id="payResult">
            <router-view/>
        </div>
    </div>
    <div v-show="isMask" class="app-mask" @click.stop="shutMask()">
        <div>
          <img src="./assets/images/loading.png" class="loading-img" alt="" />
        </div>
        <div>{{ maskText }}</div>
    </div>
  </div>
</template>

<script>
import { reportToParent , initHook , removePreload , reportEvent , loadFingerPrint, getCookie, delCookie } from "./utils/hook";
import CONSTS_CONFIG from "./baseConfig/consts";
import PayHeader from "./components/common/Header/index";
const HEIGHT_CLASS_NAME = {
    "common":["common-height-fa" , "common-height-ch"],
    "middle":["middle-height-fa" , "middle-height-ch"]
};
import { loadLanguageAsync  } from "./utils/i18n";
import { getFirstBonusStatus, getDepositGiftStatus} from "@/server/api";
export default {
    name: "App",
    components:{
        PayHeader
    },
    provide(){
        return {
            ngResetBodyHeight:this.ngResetBodyHeight,
            goTransactions: this.goTransactions,
            showMask:this.showMask,
            shutMask:this.shutMask
        }
    },
    data() {
        return {
            titleName:"Deposit",
            tempTitle:"Deposit",
            isTitleBack:false,
            heightClassFa:"common-height-fa",
            heightClassCh:"common-height-ch",
            cartoonClass:"animated fadeInUp",
            isMask:true,
            maskText:"Loading"
        };
    },
    created() {
        let toast = getCookie('toast')
        let params = initHook(this , country => {
            // 用户信息获取失败，强制跳转失败界面
            if (!country) {
                this.$router.push({
                    path: "/"
                });                
            }
        });
        if (toast && toast == 2) {
            this.$toast.show({
                text: "Deposit to Place Bet",
                time: "2000",
                color: "#0D9737",
            });
            delCookie('toast')
        }
        // 非测试状态
        if (!params.isPreTesting) {
            !params.type && (params.type = this.$store.state.type);
            !params.country && (params.country = this.$store.getters['country']);
            if (params.country) {
               
                this.getBonusStatus(params.country);
                this.getDepositGiftStatus(params.country);
                if (params.type == "withdraw") {
                    this.$router.push({
                        path: "/" + params.country + "Withdraw",
                        query:{
                            rand:Math.random()
                        }
                    });                  
                } else {
                    // 只有肯尼亚有快速充值
                    this.$router.push({
                        path: "/" + params.country,
                        query:{
                            rand:Math.random()
                        }
                    });                    
                }
            }
        }
        // 尽量避免对主流程操作造成影响
        var self = this;
        window.selfReportAction = function(params){ 
            self.$nextTick(() => {
                reportEvent(self , params);
            });
        };  
        window.updateGiftInfo = (res) => {
            this.getDepositGiftStatus(params.country);
        }
    },
    mounted() {
        removePreload(this);
        // 进入充值，基本都存在VISIT_ID 缓存
        window.top.setFbevents &&  window.top.setFbevents('payment' , 0, this.userInfo.userId);
        setTimeout(() => {
            loadFingerPrint();
        }, 5000); 
        setTimeout(()=>{
            let lang =  window.localStorage.getItem('lang');
            if(lang){
                
                loadLanguageAsync(lang);
            }
            else{
                loadLanguageAsync("en");
            }},0
        )
        this.$root.$on('onClose',()=>{
            this.onClose()
        })
    },
    computed: {
        userInfo () {
            return this.$store.getters["userInfo"];
        },
        isScrollful () {
            const list = ['withdrawResult', 'depositResult', 'ugWithdraw', 'UgDeposit']
            return list.indexOf(this.$route.name) > -1
        }
    },
    watch:{
        $route(to, from) {
            this.showMask();
            // 标题 和 返回按钮
            this.tempTitle = to.meta.name;
            this.titleName = to.meta.name;
            this.isTitleBack = true;
            to.meta && (to.meta.layoutLv == 0) && (this.isTitleBack = false);
            // 页面高度调整
            let hClass = "common"
            to.meta && to.meta.heightType && (hClass = to.meta.heightType);
            !HEIGHT_CLASS_NAME[hClass] && (hClass = "common");
            this.resetBodyHeight(hClass);
        }
    },
    methods: {
        async getBonusStatus(cn) {
            let { data, result } = await getFirstBonusStatus({
                country: cn,
            });
            if (result == 1 && data) {
                this.$store.commit("setFirstBonusObj", {
                    rate: data.rate,
                    min: data.min,
                    max: data.max,
                    status: !!data.tipstatus
                })
            }
        },
        async getDepositGiftStatus(cn) {
            let { data, result } = await getDepositGiftStatus({
                country: cn,
            });
            if (result == 1 && data) {
                this.$store.commit("setDepositGiftStatus", data.status );
                this.$store.commit("setDepositGiftRate", data.bonusRatio );
                this.$store.commit("setDepositGiftList", data.awardCouponVOs);
               
            }
        },
        disableAction(event){
            event && event.stopPropagation();
        },
        showMask(txt){
            !txt && (txt = "Loading");
            this.maskText = txt;
            this.isMask = true;
        },
        shutMask(){
            this.isMask = false;
        },
        ngResetBodyHeight(isOpen){
            var hClass = isOpen ? "middle" : "common";
            this.resetBodyHeight(hClass);
        },
        resetBodyHeight(hClass){
            this.heightClassFa = HEIGHT_CLASS_NAME[hClass][0];
            this.heightClassCh = HEIGHT_CLASS_NAME[hClass][1];
        },
        onClose(){
            this.cartoonClass = "animated fadeOutDown";
            this.$myQueue.setDelayer(null , () => { 
                reportToParent(this , {cmd:CONSTS_CONFIG.PARENT_CMD.CANCEL});
            } , null , 200);
        },
        goTransactions () {
            let origin = window.isBangbetCasinoDomain ? window.location.origin + '/games/#' : window.location.origin
            if (window.isCasinoDomain) {
                window.top.location.href = origin + '/Transactions'
            } else {
                origin = origin.indexOf('localhost') > -1? 'https://www.hw.luckygames.team': origin
                window.top.location.href = `${origin}/me/transactions?fromPage=user`
            }
        },
    },
};
</script>

<style  lang="scss">

.common-height-fa { height: 8.64rem; }
.common-height-ch { height: 7.64rem; }

.middle-height-fa { height: 10.64rem; }
.middle-height-ch { height: 9.64rem; }

.container{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #FFFFFF;
  border-radius: 32px 32px 0px 0px;
  overflow: hidden;
  padding-bottom: 50px;
}
.scrollful {
  box-sizing: border-box;
  height: 100%;
  border-radius: 0px;
  .content {
    height: 95%;
    overflow: auto;
  }
}

.preventMask {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden; 
}

.app-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.49);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;  
  color: #fff;
  font-size: 24px;
  z-index: 100000;
  font-weight: bold;
}

.app-mask-txt {
    width: 100%;
    text-align: center;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

.loading-img {
  width: 50px;
  height: 50px;
  -webkit-transform: rotate(360deg);
  animation: rotation 1s linear infinite;
  -moz-animation: rotation 1s linear infinite;
  -webkit-animation: rotation 1s linear infinite;
  -o-animation: rotation 1s linear infinite;
}

.content {
  padding: 0 .32rem;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling : touch;
}

.content::-webkit-scrollbar {
  display: none;
}

.animated {
    -webkit-animation-duration: 0.3s;
    animation-duration: 0.3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    /*animation: 0.25s linear;*/
}

@-webkit-keyframes fadeInUp {
    from {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }
    to {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }
    to {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

.fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
}

@-webkit-keyframes fadeOutDown {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }
}

@keyframes fadeOutDown {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }
}

.fadeOutDown {
    -webkit-animation-name: fadeOutDown;
    animation-name: fadeOutDown;
}

</style>



// WEBPACK FOOTER //
// src/App.vue